import engine from '../Support/Engine';


export const setMatter = (dataset) => {
	return {
		type: 'SET_MATTER',
		data: dataset
	};
};

export const newMatter = (token) => {
	return dispatch => {
		dispatch(clearMatter());
		// engine.post('/matter/edit', {tk: token, c: 'dsdz2377'})
		engine.post('/matter/new', {tk: token}) // /matter/new, no c:
			.then(response => {
				if(response.data.result) {
					dispatch(setMatter(response.data.response));
					dispatch(setToast('Matter ' + response.data.response.matter.code + ' has been created', 'positive'));
				}
			})
			.catch(error => {
				console.log(error);
			});
	}
}

export const loadMatter = (token,id) => {
	return dispatch => {
		engine.post('/matter/edit', {tk: token, c: id})
			.then(response => {
				if(response.data.result) {
					dispatch(setMatter(response.data.response));
				}
			})
			.catch(error => {
				console.log(error);
			});
	}
}

/** ########=======~~~~~~~-------   MATTER VALUE EDITING   -------~~~~~~~========######## **/

export const toggleCounterClaim = () => {
	return {
		type: 'TOGGLE_COUNTER_CLAIM'
	};
}

export const addRow = (id) => {
	return {
		type: 'ADD_ROW',
		id: id
	};
}

export const toggleRow = (id,row) => {
	return {
		type: 'TOGGLE_ROW',
		id: id,
		row: row
	};
}

export const shiftRow = (id,row,to) => {
	return {
		type: 'SHIFT_ROW',
		id: id,
		row: row,
		to: to
	};
}

export const prepRow = (id,row) => {
	return {
		type: 'PREP_ROW',
		id: id,
		row: row
	};
}

export const freeRow = () => {
	return {
		type: 'FREE_ROW'
	};
}

export const dropRow = () => {
	return {
		type: 'DROP_ROW'
	};
}

export const editListValue = (id,row,item,value) => {
	return {
		type: 'EDIT_LIST_VALUE',
		id: id,
		row: row,
		item: item,
		value: value
	};
}

export const editValue = (id,value) => {
	return {
		type: 'EDIT_VALUE',
		id: id,
		value: value
	};
}

export const editField = (row,id,value) => {
	return {
		type: 'EDIT_FIELD',
		row: row,
		id: id,
		value: value
	};
}

export const saveMeasuresStart = () => {
	return {
		type: 'SAVE_MEASURES_START'
	};
}

export const saveMeasures = (token,matter_id, measures, has_counter, angle) => {
	return dispatch => {
		dispatch(saveMeasuresStart());
		const save_data = {
			tk: token,
			id: matter_id,
			save: 'measures',
			content: measures,
			has_counter: has_counter
		};
		if(angle !== null && angle !== undefined && angle !== '')
			save_data.angle = angle;
		engine.post('/matter/save/', save_data).then(response => {
			if(response.data.result) {
				dispatch(setResults(response.data.response));
			}
		})
		.catch(error => {
			console.log(error);
		});
	}
}

export const setResults = (dataset) => {
	return {
		type: 'SET_RESULTS',
		data: dataset
	};
}


export const clearMatter = () => {
	return {
		type: 'CLEAR_MATTER'
	};
}


export const deleteMatter = (token,matter_id,matter_code,history) => {
	return dispatch => {
		dispatch(setModal('loadal'));
		const data = {
			tk: token,
			id: matter_id,
			code: matter_code
		};
		engine.post('/matter/delete/', data).then(response => {
			dispatch(setModal(null));
			if(response.data.result) {
				dispatch(clearMatter());
				dispatch(setToast('Matter ' + matter_code + ' has been deleted', 'neutral'));
				history.push('/dashboard');
			}
		})
		.catch(error => {
			console.log(error);
			dispatch(setModal(null));
		});
	}
}


export const setMatterValue = (item,value) => {
	return {
		type: 'SET_MATTER_VALUE',
		item: item,
		value: value
	};
}



/** ########=======~~~~~~~-------   OFFERS EDITING   -------~~~~~~~========######## **/


export const addOffer = (context) => {
	return {
		type: 'ADD_OFFER',
		context: context
	};
}

export const editOffer = (context,row,item,value) => {
	return {
		type: 'EDIT_OFFER',
		context: context,
		row: row,
		item: item,
		value: value
	};
}

export const toggleOffer = (context,row) => {
	return {
		type: 'TOGGLE_OFFER',
		context: context,
		row: row
	};
}

export const prepOffer = (context,row) => {
	return {
		type: 'PREP_OFFER',
		context: context,
		row: row
	};
}

export const freeOffer = () => {
	return {
		type: 'FREE_OFFER'
	};
}

export const dropOffer = () => {
	return {
		type: 'DROP_OFFER'
	};
}

export const saveOffersStart = () => {
	return {
		type: 'SAVE_OFFERS_START'
	};
}

export const saveOffers = (token, matter_id, primary, counter) => {
	return dispatch => {
		dispatch(saveOffersStart());
		const save_data = {
			tk: token,
			id: matter_id,
			save: 'offers',
			content: {
				primary: primary,
				counter: counter
			}
		};
		engine.post('/matter/save/', save_data).then(response => {
			// if(response.data.result) {
			// 	dispatch(setResults(response.data.response));
			// }
			dispatch(saveOffersEnd());
		})
		.catch(error => {
			console.log(error);
		});
	}
}

export const saveOffersEnd = () => {
	return {
		type: 'SAVE_OFFERS_END'
	};
}

export const acceptOffer = (context,row) => {
	return dispatch => {
		dispatch(editOffer(context,row,'accepted',true));
		dispatch(setModal(null));
		dispatch(setMatterValue('offer_accepted', context));
	};
}


export const declineOffer = (context,row) => {
	return dispatch => {
		dispatch(editOffer(context,row,'accepted',false));
		dispatch(setModal(null));
		dispatch(setMatterValue('offer_accepted', null));
	};
}


/** ########=======~~~~~~~-------   ACCOUNT MANAGEMENT   -------~~~~~~~========######## **/


export const saveAuth = (token,expiry) => {
	return dispatch => {
		dispatch(setAuth(token,expiry));
		localStorage.setItem('xso_token', token);
		localStorage.setItem('xso_token_expiry', expiry);
		dispatch(loadAccount(token));
	}
}

export const logout = (sendToast) => {
	if(sendToast === undefined) sendToast = true;
	return dispatch => {
		localStorage.removeItem('xso_token');
		localStorage.removeItem('xso_token_expiry');
		dispatch(clearAuth());
		if(sendToast)
			dispatch(setToast('You have been signed out', 'neutral'));
	}
}


export const setAuth = (token,expiry) => {
	return {
		type: 'SET_AUTH',
		token: token,
		expiry: expiry
	};
}

export const clearAuth = () => {
	return {
		type: 'CLEAR_AUTH'
	};
}

export const loadAccount = (token) => {
	return dispatch => {
		engine.post('/account/pull/', {slice: token})
			.then(packet => {
				if(packet.data.result) {
					dispatch(setUser(packet.data.response));
				}
				else {
					console.log(packet.data);
				}
				dispatch(setAuthChecked(true));
			})
			.catch(error => {
				console.log(error);
			});
	};
}

export const setUser = (account) => {
	return {
		type: 'SET_USER',
		user: account
	};
}

export const preauth = () => {
	return dispatch => {

		const token = localStorage.getItem('xso_token');
		const expiry = localStorage.getItem('xso_token_expiry');

		if(new Date().getTime() > +expiry || !token) {
			dispatch(logout(false));
			dispatch(setAuthChecked(true));
			return;
		}

		dispatch(saveAuth(token,expiry));

	}
}

export const setAuthChecked = (status) => {
	return {
		type: 'SET_AUTH_CHECKED',
		status: status
	};
}

export const setModal = (content) => {
	return {
		type: 'SET_MODAL',
		content: content
	};
}


export const setToast = (text,kind) => {
	return dispatch => {
		dispatch(clearToast());
		dispatch(popToast(text,kind, setTimeout(() => {
			dispatch(clearToast());
		}, 6000) ));
		
	}
}

export const popToast = (text,kind,timeout) => {
	return {
		type: 'SET_TOAST',
		text: text,
		kind: kind,
		timeout: timeout
	};
}

export const clearToast = () => {
	return {
		type: 'CLEAR_TOAST'
	};
}


// WEBPACK FOOTER //
// ./src/Store/actions.js